import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledCrmEnrichmentJobTypeBulletList = styled.ul`
    margin: 30px 0 0 10px;
`;

export const StyledCrmEnrichmentJobTypeBulletListItem = styled.li`
    display: flex;
    width: fit-content;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};

    &::before {
        display: inline-block;
        content: "";
        border-radius: 50%;
        text-align: center;
        margin: auto;
        background-color: ${colorsPalettes.carbon[400]};
        width: 3px;
        height: 3px;
        margin-right: 10px;
    }
`;

export const StyledCrmEnrichmentJobTypeSubtitle = styled.h5`
    margin: 40px auto 12px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    text-align: center;
`;

export const StyledCrmEnrichmentJobTypeButtonsWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 16px;
`;
